import { TENANT_GOVERNANCE_PERMISSION_GROUPS } from "../../constants/tenantGovernancePermissions";

export const TENANT_ADMIN_INTEGRATIONS = [
  {
    key: "integration_moneybird",
    slug: "moneybird",
    title: "Moneybird",
    description: "Facturatiekoppeling, synchronisatie en verbindingsstatus met Moneybird.",
    permissionsAny: TENANT_GOVERNANCE_PERMISSION_GROUPS.integrationsView,
  },
  {
    key: "integration_tu",
    slug: "technische-unie-oci",
    title: "Technische Unie / OCI",
    description: "OCI/TU configuratie voor inkoop, artikeldata en bestelstroom.",
    permissionsAny: TENANT_GOVERNANCE_PERMISSION_GROUPS.integrationsView,
  },
  {
    key: "integration_mail",
    slug: "mailinstellingen",
    title: "Mailinstellingen",
    description: "Uitgaande mailinstellingen en basis deliverability-configuratie.",
    permissionsAny: TENANT_GOVERNANCE_PERMISSION_GROUPS.integrationsView,
  },
  {
    key: "integration_pdf_templates",
    slug: "pdf-templates",
    title: "PDF templates",
    description: "Documentoutput en standaardrapportages voor tenant-documenten.",
    permissionsAny: TENANT_GOVERNANCE_PERMISSION_GROUPS.integrationsView,
  },
  {
    key: "integration_branding",
    slug: "huisstijl-branding",
    title: "Huisstijl / branding",
    description: "Visuele identiteit en brandinginstellingen voor tenant-uitvoer.",
    permissionsAny: TENANT_GOVERNANCE_PERMISSION_GROUPS.integrationsView,
  },
];

export function getIntegrationDetailPath(slug) {
  return `/tenant-admin/integrations/${slug}`;
}

export function findIntegrationBySlug(slug) {
  const value = String(slug || "").trim().toLowerCase();
  return TENANT_ADMIN_INTEGRATIONS.find((integration) => integration.slug === value) || null;
}
